import classNames from 'classnames';
import React from 'react';
import WizardImage from 'src/images/wizard_image.jpeg';

export const WizardArtBoard = ({ hide = false }: { hide?: boolean }) => (
  <div
    className={classNames('relative flex-1 justify-end hidden xl:block transition-opacity', {
      'opacity-100': !hide,
      'opacity-0': hide,
    })}
  >
    <div
      className='fixed inset-y-0 right-0 -z-10 w-[368px] bg-right bg-cover bg-no-repeat'
      style={{
        backgroundImage: `url(${WizardImage})`,
      }}
    />
  </div>
);
